<!-- Created by henian.xu on 2017/10/22. -->
<template>
  <Page>
    <container ref="container">
      <List>
        <StoreActivityItem
          :to="`./addActivity/${item.id}`"
          v-for="(item) in goodsList"
          :key="item.id"
          :data="item"
        />
      </List>

      <infinite-loading
        ref="infinite"
        :disabled="infiniteDisabled"
        @infinite="onInfinite"
      />
    </container>
    <PageBar>
      <Button
        to="./addActivity"
        theme="main"
        label="新增活动"
      />
    </PageBar>
  </Page>
</template>

<script>
import storeMixin from '@/mixins/storeMixin';
import infiniteLoading from '@/mixins/infiniteLoading';

export default {
  name: 'StoreActivity',
  mixins: [storeMixin, infiniteLoading],
  data() {
    return {
      goodsList: [],
    };
  },
  methods: {
    getListData({ currentPage, pageSize } = {}) {
      return this.$api.Buyer.Sp.ShopStoreActivity.shopStoreActivityList({
        currentPage:
          currentPage || this.pagination.currentPage
            ? this.pagination.currentPage + 1
            : 1,
        pageSize,
      }).then(json => {
        const res = json.data;
        this.goodsList = this.goodsList.concat(res.data);
        return Promise.resolve(json);
      });
    },
  },
  activated() {
    this.infiniteDisabled = true;
    this.goodsList = [];
    this.pagination = {};
    this.$nextTick(() => {
      this.infiniteDisabled = false;
    });
  },
};
</script>

<style lang="scss">
</style>
